export const getAssetsByCategory = (assets, category) => {
  return assets.filter(asset => asset.categories.indexOf(category) !== -1)
}

export const getAssetIndex = (assets, id) => {
  const index = assets.findIndex(asset => asset.id === id)
  return index >= 0 ? index : false
}
